var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3896,
    cy: 16.1571,
    r: 5.15523,
    stroke: "#9E9D9C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6653 2.96892C14.5329 0.343692 18.248 0.343692 19.1156 2.96892C19.9815 5.58902 22.8621 6.95306 25.4394 6.00104C28.0475 5.03769 30.3395 7.95224 28.8465 10.2152C27.3279 12.5168 28.0356 15.6208 30.4026 17.036C32.7472 18.4379 31.9346 22.0501 29.1828 22.3049C26.4416 22.5586 24.4494 25.0436 24.8133 27.7772C25.1731 30.4805 21.8359 32.1089 19.9024 30.112C17.987 28.1339 14.7939 28.1339 12.8785 30.112C10.9451 32.1089 7.60786 30.4805 7.96769 27.7772C8.33158 25.0436 6.33935 22.5586 3.59816 22.3049C0.846403 22.0501 0.0337755 18.4379 2.37841 17.036C4.74536 15.6208 5.45306 12.5168 3.93447 10.2152C2.44142 7.95224 4.73351 5.03769 7.34154 6.00104C9.91888 6.95306 12.7994 5.58902 13.6653 2.96892Z",
    stroke: "#9E9D9C",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b94dd470bc79d59a3e3c3e7f2fecb590.svg";
export { ForwardRef as ReactComponent };